module.exports = __webpack_public_path__ + "img/energyImg4.beb02b85.png";